import React, { ComponentProps, FunctionComponent } from "react";

const AnnouncementSpeakerIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 21",
        fill: "currentColor",
        strokeWidth: 0.5,
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.06655 7.95902C9.32563 7.78263 9.63858 7.71768 9.94713 7.77746C10.2549 7.83576 10.5229 8.01216 10.6993 8.27195C10.8757 8.53101 10.9399 8.84319 10.8808 9.15096C10.8218 9.45872 10.6461 9.72664 10.3863 9.90304C10.1863 10.0381 10.1346 10.3104 10.2704 10.5104C10.3546 10.6352 10.4919 10.7016 10.6321 10.7016C10.717 10.7016 10.8019 10.6772 10.8772 10.6263C11.3304 10.3185 11.6367 9.85283 11.7393 9.31627C11.8419 8.77823 11.7289 8.23355 11.4219 7.78113C11.1141 7.32798 10.6483 7.02169 10.111 6.91983C9.57365 6.81724 9.02745 6.92943 8.57499 7.23719C8.3757 7.37299 8.3233 7.64459 8.45911 7.8446C8.59492 8.04314 8.86652 8.09555 9.06655 7.95902Z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.41967 14.4972L1.49348 14.6064C1.96293 15.2965 2.72612 15.667 3.50266 15.667C3.94257 15.667 4.38545 15.543 4.7818 15.295L7.41473 19.1705C7.65019 19.5182 8.00669 19.7529 8.4193 19.8311C8.51894 19.8503 8.61859 19.8599 8.71823 19.8599C9.02897 19.8599 9.33381 19.7669 9.59658 19.5883C9.94348 19.3536 10.1775 18.9971 10.2565 18.5853C10.3354 18.1727 10.2491 17.755 10.0129 17.4073L7.72479 14.0374L12.6811 13.6462C12.7077 13.6477 12.735 13.6514 12.7616 13.6514C13.1225 13.6514 13.4436 13.5584 13.7145 13.3739C14.4017 12.9082 14.6504 11.9391 14.415 10.646C14.2024 9.47469 13.6134 8.1359 12.7579 6.87755C11.3104 4.74763 9.40769 3.31641 8.02283 3.31641C7.66041 3.31641 7.34007 3.4094 7.06918 3.59317C6.77615 3.79244 6.57169 4.08398 6.44179 4.44119L3.70626 10.0127L2.06322 11.1301C1.52736 11.4932 1.16568 12.0438 1.04389 12.68C0.922106 13.3162 1.05578 13.9606 1.41967 14.4972ZM6.73408 14.1355L9.28934 17.8973C9.39416 18.0516 9.43254 18.2368 9.39711 18.4199C9.36242 18.6022 9.25908 18.7601 9.10481 18.8642C8.95128 18.9682 8.76601 19.0074 8.58223 18.9727C8.39918 18.938 8.24122 18.8339 8.13715 18.6797L5.50876 14.8102L6.50373 14.1334L6.72664 14.1157C6.73033 14.1216 6.73039 14.1296 6.73408 14.1355ZM8.02135 4.18952C8.94178 4.18952 10.6157 5.28108 12.0337 7.3675C12.822 8.52844 13.3623 9.74777 13.5534 10.8017C13.7203 11.7198 13.5999 12.3937 13.2213 12.6497C13.1622 12.6903 13.0943 12.7206 13.0198 12.7413L12.6655 12.7693C11.7288 12.7007 10.1204 11.6165 8.74842 9.59718C7.40284 7.61765 6.94964 5.74091 7.23087 4.81019L7.39104 4.48396C7.43975 4.41754 7.49438 4.3585 7.55785 4.31495C7.68259 4.23155 7.83831 4.18952 8.02135 4.18952ZM6.40046 6.50706C6.62853 7.58978 7.17696 8.83934 8.02653 10.0888C8.85395 11.3066 9.83048 12.2956 10.7738 12.9191L6.5725 13.2513L4.55086 10.2739L6.40046 6.50706ZM1.90159 12.8439C1.97909 12.4373 2.21085 12.0852 2.55407 11.8527L3.93066 10.9162L5.74716 13.59L4.3691 14.5259C3.66272 15.0064 2.69653 14.8218 2.21593 14.1148L2.14139 14.0056C1.90887 13.6631 1.82408 13.2513 1.90159 12.8439Z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.0244 1.39269L12.7454 3.97815C12.7211 4.21801 12.896 4.43278 13.1359 4.45789C13.1507 4.45936 13.1662 4.4601 13.1809 4.4601C13.4016 4.4601 13.592 4.29256 13.6157 4.06746L13.8939 1.482C13.9183 1.24214 13.7441 1.02737 13.5035 1.00226C13.2629 0.977908 13.0481 1.15282 13.0244 1.39269Z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.016 6.13067C15.0987 6.13067 15.1821 6.10779 15.2559 6.05908L17.7929 4.38739C17.9944 4.25454 18.0497 3.98368 17.9176 3.78293C17.7847 3.58071 17.5131 3.52535 17.3123 3.6582L14.7762 5.32989C14.5747 5.46274 14.5186 5.7336 14.6514 5.93508C14.7348 6.06203 14.8743 6.13067 15.016 6.13067Z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.6444 8.19836L15.6957 7.66696C15.4581 7.62489 15.2307 7.7821 15.1879 8.01975C15.1451 8.2574 15.3031 8.48472 15.54 8.52753L18.4887 9.05819C18.5152 9.06262 18.5411 9.06483 18.5662 9.06483C18.7736 9.06483 18.9581 8.91648 18.9957 8.70541C19.0393 8.4685 18.8813 8.24117 18.6444 8.19836Z",
    })
  );
};

const ForwardRef = React.forwardRef(
  AnnouncementSpeakerIcon
) as FunctionComponent<ComponentProps<"svg">>;

export default ForwardRef;
